export function Mark({ size = 40, ink = 'currentColor' }) {
  return (
    <svg className="logo" width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <g stroke={ink} strokeWidth="2.6" strokeLinecap="round" opacity=".85">
        <line x1="50" y1="33" x2="50" y2="23.5" /><line x1="67" y1="50" x2="76.5" y2="50" />
        <line x1="50" y1="67" x2="50" y2="76.5" /><line x1="33" y1="50" x2="23.5" y2="50" />
      </g>
      <g fill="none" strokeWidth="7" strokeLinecap="round">
        <path d="M15.69 36.14 A37 37 0 0 1 36.14 15.69" stroke="#D93B33" />
        <path d="M63.86 15.69 A37 37 0 0 1 84.31 36.14" stroke="#2EA85C" />
        <path d="M84.31 63.86 A37 37 0 0 1 63.86 84.31" stroke="#2E7FD4" />
        <path d="M36.14 84.31 A37 37 0 0 1 15.69 63.86" stroke="#E8912E" />
      </g>
      <g fill="none" strokeWidth="6.5">
        <circle cx="50" cy="13" r="8" stroke="#D93B33" /><circle cx="87" cy="50" r="8" stroke="#2EA85C" />
        <circle cx="50" cy="87" r="8" stroke="#2E7FD4" /><circle cx="13" cy="50" r="8" stroke="#E8912E" />
      </g>
      <circle cx="50" cy="50" r="13" fill="none" stroke={ink} strokeWidth="7" />
    </svg>
  );
}

export function Wordmark({ size = 40, ink = 'currentColor' }) {
  return (
    <div className="brand">
      <Mark size={size} ink={ink} />
      <span className="wm">IMT&nbsp;<b>LOGIC</b></span>
    </div>
  );
}
